import axios from './axiosInstance';

//Crew Create
export const createCrew = (data) => {
  return axios.post('/crew', data);
};

//Crew Assign
export const createCrewAssign = (data) => {
  return axios.post('/crew/assign', data);
};

//Get Crew All
export const getCrewAll = () => {
  return axios.get('/crewAll');
};

//Get Crew Assignment
export const getCrewAssignment = () => {
  return axios.get('/crewAssignment');
};

// Update Crew Assignment
export const updateCrewAssignment = (id, data) => {
  return axios.put(`/crewAssignment/${id}`, data);
};

// Schedule Workmen (no id param, just data)
export const CrewScheduleWorkmen = (data) => {
  return axios.post(`/scheduleWorkmen`, data);
};

//Get Labour Categories
export const getLabourCategories = () => {
  return axios.get('/labour-categories');
};